<template>
  <div class="battery-order-view__container battery-order-view__container--order" v-if="orderProducts.length">
    <ProductHeader></ProductHeader>
    <Product v-for="(product, index) in orderProducts" :index="index" :key="index" :product="product"></Product>
    <div class="css-grid battery-order-view__row battery-order-view__row--total">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div class="h-right-align">Total:</div>
      <div class="h-center-align">{{ formattedOrderTotal }}</div>
      <div class="h-center-align">{{ totalBatteries }} batteries</div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DataMethods from '../../utils/DataMethods.js';
  import ProductHeader from './ProductHeader.vue';
  import Product from './Product.vue';

  export default {
    name: 'ProductCartView',
    mixins: [DataMethods],
    components: {
      ProductHeader,
      Product
    },
    computed: {
      ...mapGetters('batteryStore', ['orderProducts', 'orderTotal', 'totalBatteries']),
      formattedOrderTotal() {
        return this.currency(this.orderTotal/100, '$', 2);
      },
    },
  };
</script>
